<template>
  <base-section id="404">
    <base-heading title="404" />

    <base-subheading
      class="primary--text"
      title="Oh!"
    />

    <base-subheading
      space="8"
      title="Die angeforderte Seite existiert nicht"
    />

    <base-img
      :src="require('@/assets/IFEA-Treuhand-GmbH-LOGO-INLINE.png')"
      class="mx-auto mb-12"
      contain
      height="350"
      width="450"
    />

    <div class="text-center">
      <base-btn :to="{ name: 'Home' }">
        Zur Hauptseite zurückkehren
      </base-btn>
    </div>
  </base-section>
</template>

<script>
  export default {
    name: 'FourOhFour',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
